import { render } from "./ContainerCard.vue?vue&type=template&id=0f895b04&scoped=true"
import script from "./ContainerCard.vue?vue&type=script&lang=js"
export * from "./ContainerCard.vue?vue&type=script&lang=js"

import "./ContainerCard.vue?vue&type=style&index=0&id=0f895b04&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f895b04"]])

export default __exports__